export const IconGrayActionsMinus: {
  name: 'icon_gray_actions_minus-fe91c49a7e6c'
} = {
  name: 'icon_gray_actions_minus-fe91c49a7e6c'
}
